import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const ProjectGallerySection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xrTcD9VXhEn9xvxL7ihk1e/2B7744E0-093D-4A32-A4A0-56108C086E6F.jpg',
    alt: 'Living room installation with TV mounted above fireplace'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k79FzfRBMtXAjx35xhnTAs/7B1046C7-CA69-48E3-9E26-6FAB371AEF13.jpg',
    alt: 'TV installation in wooden cabinet on boat'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4CFJJ4FUDz2RnS9TkzV4VK/090120DF-4F50-452B-BE33-B4663C0B7BDD.jpg',
    alt: 'Outdoor entertainment area with TV under tiki hut by the water'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/osaFfMF1YSuyMnaeJ3Bd6B/B70D8FD4-48B7-4080-884A-A22AD29C172A.jpg',
    alt: 'Modern living room with TV mounted on stone fireplace'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uHN2vZQu6tGwm9PstwyPa6/IMG_0114.png',
    alt: 'TV mounted on white wall with news broadcast'
  }];
  const nextSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  // Auto-advance slides
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  const scrollToContactForm = () => {
    const contactForm = document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="gallery-section" className="py-16 md:py-24 bg-gray-50" data-id="element-254" data-mp="277uer7xzujpl">
      <div className="container mx-auto px-4" data-id="element-255" data-mp="2b7movp31cxx2">
        <div className="text-center mb-12" data-id="element-256" data-mp="2b6blvrhezu70">
          <p className="text-blue-600 font-semibold mb-2" data-id="element-257" data-mp="3k6nw9pssjqqx">OUR WORK</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-258" data-mp="3f6rr3n8cxt9s">
            Recent Installations
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-259" data-mp="3b4eoh7owqbh8">
            Browse through our gallery of recent projects showcasing our
            expertise in TV mounting, home theater setups, and outdoor
            entertainment solutions.
          </p>
        </div>
        {/* Carousel */}
        <div className="relative max-w-5xl mx-auto mb-12" data-id="element-260" data-mp="2pd0fusvmhm8">
          <div className="overflow-hidden rounded-xl shadow-xl aspect-video" data-id="element-261" data-mp="2r7qfnj08zx6">
            {images.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-500 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`} data-id="element-262" data-mp="3p4pfcaq7vq2e" data-mpi={index}>
                <img src={image.url} alt={image.alt} className="w-full h-full object-cover" data-id="element-263" data-mp="lnz6lo392yx0" />
              </div>)}
            {/* Navigation arrows */}
            <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors" aria-label="Previous image" data-id="element-264" data-mp="xz9ocs5t046t">
              <ChevronLeft className="w-6 h-6" data-id="element-265" data-mp="16wk1kj26m3ed" />
            </button>
            <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors" aria-label="Next image" data-id="element-266" data-mp="1bxgc3fh1gnsr">
              <ChevronRight className="w-6 h-6" data-id="element-267" data-mp="1qmm86ukkxxwf" />
            </button>
          </div>
          {/* Indicator dots */}
          <div className="flex justify-center mt-4 space-x-2" data-id="element-268" data-mp="1up8y2pxox8qz">
            {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full transition-colors ${index === currentIndex ? 'bg-blue-600' : 'bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-269" data-mp="1zolr5sf5nc20" data-mpi={index} />)}
          </div>
        </div>
        {/* CTA */}
        <div className="text-center" data-id="element-270" data-mp="1qrtq9c3d0029">
          <p className="text-xl text-gray-700 mb-6" data-id="element-271" data-mp="1qsv23is78ql1">
            Ready to upgrade your place with  I75 Audio & Video,
            LLC solutions?
          </p>
          <button onClick={scrollToContactForm} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-300 inline-flex items-center" data-id="element-272" data-mp="z0njwdx1p64j">
            Get Your Free Quote
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-273" data-mp="17zr4jmbv1tl5">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-274" data-mp="2jibpu34vjjax" />
            </svg>
          </button>
        </div>
      </div>
    </section>;
};
export default ProjectGallerySection;